'use strict';

var is = require('./is.cjs');
var globalConfig = require('../../../../../../../motion-utils/dist/es/global-config.cjs');

function addValueToWillChange(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */
    if (is.isWillChangeMotionValue(willChange)) {
        return willChange.add(key);
    }
    else if (!willChange && globalConfig.MotionGlobalConfig.WillChange) {
        const newWillChange = new globalConfig.MotionGlobalConfig.WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

exports.addValueToWillChange = addValueToWillChange;
//# sourceMappingURL=add-will-change.cjs.map
